export default __webpack_public_path__ + "static/media/dollar-bills.0e6a8733.svg";